import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

/**
 * Provides a composed new relic wrapper to hide internal functions.
 */

var NewRelicWrapper = function NewRelicWrapper(props) {
  // Run once on new render. If new relic is enabled, window.newrelic.setPageViewName has to be fired once.
  // Make this call before the window load event fires in order for it to appear correctly.
  useEffect(function () {
    if (window && window.newrelic && props.pageViewName && props.pageViewName.startsWith('/')) {
      if (props.pageViewHost) {
        window.newrelic.setPageViewName(props.pageViewName, props.pageViewHost);
      } else {
        window.newrelic.setPageViewName(props.pageViewName);
      }
    }
  }, []); // script tag is copied from NewRelic for browser instrumentation

  return React.createElement(Helmet, {
    defer: true
  }, React.createElement("script", {
    type: "text/javascript"
  }, props.newRelicFunction(props.newRelicBrowserScript)));
};

var NewRelic = function NewRelic(props) {
  return React.createElement(NewRelicWrapper, Object.assign({}, props, {
    newRelicFunction: newRelicBrowser
  }));
};

function newRelicBrowser(browserScript) {
  var newRelicBrowserScript = "" + browserScript;
  return newRelicBrowserScript;
}

export default NewRelic;
export { NewRelic };
//# sourceMappingURL=react-new-relic-browser.esm.js.map
